export const addDiscountCodeErrorCodes = {
    SUCCESS: 10,
    WRONG_CODE: 20,
    NO_ACTIVE_PROMOTION: 30,
    WRONG_PROMOTION_TIME: 40,
}